export interface FormProgressData {
  totalQuestions: number;
  answeredQuestions: number;
  compliance: string;
}

export interface FormProgressResponse {
  data: FormProgressData;
  message: string;
  code: number;
}

export enum progressBarEndpoint {
 formsProgress = 'forms/progress',
}
